import { PlusOutlined } from "@ant-design/icons";
import { Button, message, Tooltip } from "antd";
import _ from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import { apiRequest } from "../../api";
import apiPaths from "../../api/paths";
import DynamicTable from "../../components/DynamicTable";
import CampusModal from "./components/CampusModal";

function Campuses() {
  const [editingKey, setEditingKey] = useState(null);
  const [campuses, setCampuses] = useState({});
  const [showCampusModal, setShowStationModal] = useState(false);

  const COLUMNS = [
    {
      title: "Name",
      dataIndex: "name",
      width: "220px",
      filterType: "search",
      fixed: "left",
    },
    {
      title: "Code",
      dataIndex: "code",
      width: "150px",
      filterType: "search",
    },
    {
      title: "City",
      dataIndex: "city",
      filterType: "search",
      width: "220px",
    },
    {
      title: "Minimum Booking Time",
      dataIndex: "minimum_booking_time",
      filterType: "search",
      width: "220px",
    },
    {
      title: "Minimum Booking Charges",
      dataIndex: "minimum_booking_charges",
      filterType: "search",
      width: "220px",
    },
    {
      title: "Created Date",
      dataIndex: "date_create",
      width: "150px",
      filterType: "date",
      render: (value) => {
        return <div>{value && moment(value).format("DD-MM-YYYY HH:mm")}</div>;
      },
    },

    {
      title: "Updated Date",
      dataIndex: "date_modify",
      filterType: "date",
      width: "150px",
      render: (value) => {
        return <div>{value && moment(value).format("DD-MM-YYYY HH:mm")}</div>;
      },
    },
  ];

  const handleRowCanceled = () => {
    setShowStationModal(false);
  };

  const handleRowEdit = (idx) => {
    setEditingKey(idx);
    setShowStationModal(true);
  };

  useEffect(() => {
    fetchCampuses();
  }, []);

  const fetchCampuses = async () => {
    const res = await apiRequest({
      path: apiPaths.campuses,
    });
    if (!res.error) {
      let campusesObj = res.results.reduce((campuses, campus) => {
        campuses[campus.id + "c"] = campus;
        return campuses;
      }, {});
      setCampuses(campusesObj);
    } else {
      message.error(res.error_description);
    }
  };

  const handleRowSave = async (row) => {
    if (editingKey == null) {
      const res = await apiRequest({
        path: apiPaths.campuses,
        method: "POST",
        data: row,
      });
      if (res.error) {
        message.error(res.error_description);
        return;
      }
      setCampuses({ [res.id + "c"]: res, ...campuses });
      setShowStationModal(false);
      return;
    }
    let key = editingKey;
    const res = await apiRequest({
      path: apiPaths.campuses + `/${key}`,
      method: "PUT",
      data: row,
    });
    if (res.error) {
      message.error(res.error_description);
      return;
    }
    campuses[editingKey + "c"] = res;
    setCampuses({ ...campuses });
    setEditingKey(null);
    setShowStationModal(false);
  };

  return (
    <div style={{ height: "80vh" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginRight: 10,
        }}
      >
        <Tooltip title="Add Campus">
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => {
              setEditingKey(null);
              setShowStationModal(true);
            }}
          />
        </Tooltip>
      </div>
      <div style={{ height: "90%", marginTop: 30 }}>
        <DynamicTable
          dataSource={Object.values(campuses)}
          columns={COLUMNS}
          scroll={{
            // x: 2250,
            y: "65vh",
          }}
          editHandler={(record) => handleRowEdit(record.id)}
          pagination={false}
        />
      </div>
      {showCampusModal ? (
        <CampusModal
          open={showCampusModal}
          onSave={handleRowSave}
          onCancel={handleRowCanceled}
          data={campuses[editingKey + "c"]}
          isUpdate={editingKey != null}
        />
      ) : null}
    </div>
  );
}

export default Campuses;
